import { WithContext } from 'schema-dts';
import { StructuredDataProps } from '../@types/types';
import Head from 'next/head';

const provider = {
  '@id': 'https://www.varsitytutors.com/#organization',
  '@type': 'Organization',
  name: 'Varsity Tutors',
  description:
    'Varsity Tutors is a live learning platform that connects students with personalized instruction to accelerate academic achievement.',
  logo: 'https://assets2.varsitytutors.com/vt-ecom/images/basics/favicons/varsity-tutors/msapplication-tile.png',
};

const audience: StructuredDataProps = {
  '@type': 'EducationalAudience',
  educationalRole: 'student',
};

const context = 'https://schema.org';

const decorate = (props: StructuredDataProps): WithContext<StructuredDataProps> => {
  switch (props['@type']) {
    case 'Service': {
      return { '@context': context, provider, audience, serviceType: 'Tutoring Service', ...props };
    }
    default:
      return { '@context': context, ...props };
  }
};

/**
 * Adds structured data to a page.
 **/
function StructuredData({ data }: { data: StructuredDataProps | StructuredDataProps[] }) {
  data = Array.isArray(data) ? data.map(decorate) : decorate(data);
  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        id="json-ld"
        key="structured-data"
        type="application/ld+json"
      />
    </Head>
  );
}

export default StructuredData;
